import { SelectionCard } from 'src/app/shared/components/payments';

import { Selection, type Props as SelectionProps } from '../../components/Selection';
import { AmountInputContext } from '../AmountInputContext';
import { useSunriseHoldoutExperiment } from '../hooks/useSunriseHoldoutExperiment';

import { Radio } from './Radio';

export function YesSelection({ children, ...selectionProps }: SelectionProps): JSX.Element {
	const { shouldUseBlueCards } = useSunriseHoldoutExperiment();
	const { shouldHideRadioButtons } = useSunriseHoldoutExperiment({
		checked: selectionProps.checked,
		isSunriseEnabled: selectionProps.isSunriseEnabled,
	});

	const radioProps = !shouldHideRadioButtons
		? {
				Radio: () => {
					return <Radio data-qa={selectionProps.qaSelectorSelection} checked={selectionProps.checked} />;
				},
			}
		: {};

	if (shouldUseBlueCards) {
		return (
			<AmountInputContext.Provider value={{ onSelectYes: selectionProps.onSelect }}>
				<SelectionCard
					type="complex"
					label={selectionProps.label}
					description={selectionProps.message}
					selected={selectionProps.checked}
					onSelect={selectionProps.onSelect}
					badgeText={selectionProps.highlight}
					{...radioProps}
				>
					{children}
				</SelectionCard>
			</AmountInputContext.Provider>
		);
	}

	return <Selection {...selectionProps}>{children}</Selection>;
}
